<script>
  import StoryHeader from '../components/story-header.svelte'
  import PlayButton from '../components/button-play.svelte'
  import BackButton from '../components/button-back.svelte'
  import {
    stories
  } from '../stores/stories.js'
  import {
    push
  } from 'svelte-spa-router'
  import {
    fade,
    fly
  } from 'svelte/transition';

  export let params = {

  }

  function playStory(e) {
    push(`/story/${params.id}/play`)
  }

  let story = $stories.find(el => el.id == params.id);
</script>

<div class="column" style="padding-top:20px;display:flex;flex-direction:column; min-height: 100%;">

  <BackButton />

  <div in:fly="{{ delay:250, y: 50, duration: 200 }}" out:fade="{{duration: 250}}" id="header" class="card four-secondary">


    <StoryHeader {...story} />
  </div>
  <div in:fade="{{ delay:350, duration: 200 }}" out:fade="{{duration: 250}}" class="full">
    <div class="image-container">
      <span class="play">
        <PlayButton on:pressed={playStory} ref={story.id} /></span>
      <img src="{story.image + '.jpg'}" srcset="{story.image + '.jpg'} 1x, {story.image + 'X2.jpg'} 2x" alt="">
    </div>


    <div style="padding: 20px;">
      <div class="card three">
        <p class="caption"><strong>Start Location:</strong> Buxton Train Station</p>
        <p class="caption"><strong>Road Crossings:</strong> Yes</p>
        <p class="caption"><strong>Wheelchair Accessible:</strong> Yes</p>
        <p class="caption" style="text-align: center;"><a href="https://docs.google.com/forms/d/e/1FAIpQLSdmwyYykVzwX0ga_EjwRuuiOvFI6aNtlxX9pHdPrc_hD9Kzyw/viewform">Give Feedback</a></p>
      </div>


      <h5>Description</h5>
      <div class="card tree">
        <p><strong>Experience Buxton like never before.</strong></p>
        <a href='https://ko-fi.com/M4M81JYWQ' target='_blank'><img height='36' style='border:0px;width:142px;height:36px;' src='https://cdn.ko-fi.com/cdn/kofi1.png?v=2' border='0' alt='Buy Me a Coffee at ko-fi.com' /></a>
        <p><em>Maybe things wouldn’t feel so heavy if I could just...flow….</em></p>
        <p>Cassie is at a crossroads. Frustrated professionally, and with her personal life in turmoil, she hops a train toBuxton in an effort to learn about Britain’s pagan past and help kickstart her life again...</p>
        <p>...But, in the shadow of St. Anne’s Well, something strange is about to surface, something that might just change the entire course of Cassie’s life…</p>
        <p><em>*Water was created entirely in accordance with social distancing regulations and designed so it can be experienced in the same manner.</em></p>
      </div>
      <h5>Cast</h5>
      <div class="card tree">
        <p class="caption"><strong>Cassie:</strong> Karren Young</p>
        <p class="caption"><strong>Alex:</strong> Liz Hann</p>
      </div>
      <h5>Creative</h5>
      <div class="card tree">
        <p class="caption"><strong>Written By:</strong> Harry Machray</p>
        <p class="caption"><strong>Sound By:</strong> Findlay Claydon</p>
        <p class="caption"><strong>Music By:</strong> Tammy Howarth</p>
        <p class="caption"><strong>Programmed by:</strong> Dylan Howells / Findlay Claydon</p>
      </div>
    </div>
  </div>
</div>

<style>
  #header {
    margin: 20px;
  }

  img {
    width: 100%;
    height: 100%;
  }

  .full {
    max-width: 100%;
    background-color: #FDFFFC;
    flex-grow: 1;
  }

  .image-container {
    position: relative;
    height: 70vw;
    background-color: #c9c9c9;
  }

  .play {
    position: absolute;
    top: 45%;
    left: 50%;
    margin-top: -28px;
    margin-left: -28px;
  }

  h5 {
    margin-top: 40px;
    margin-bottom: 30px;
  }

@media only screen and (min-width: 500px) {
  .column {
    max-width:370px; margin: 0 auto;
  }
  .image-container {
    height: 300px;
  }
}
</style>
